/**
 * True when a keyboard event target is a field the user is actively typing into
 * (input / textarea / select / contenteditable). Every global keydown handler in
 * the shortcut system (Cmd/Ctrl+K, `?`, `g → section`, page-scoped keys) uses
 * this so a shortcut never fires while the operator is editing text.
 */
export const isEditableTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  const tag = target.tagName;
  return (
    tag === 'INPUT' ||
    tag === 'TEXTAREA' ||
    tag === 'SELECT' ||
    target.isContentEditable
  );
};
